<template lang="pug">
.card-box
  h4.page-title.m-b-20 {{ $t('sign-in-title') }}
  .row
    .col-md-4.col-lg-3
      img.img-fluid.img-thumbnail(src="webp-share.gif")
    .col-md-8.col-lg-9
      p {{ $t('signin-description') }}
      p
        strong {{ $t('signin-catch')}}
      .btn-group
        button.btn.btn-primary.btn-lg(v-on:click="signIn")
          | {{ $t('sign-in') }}
          i.mdi.mdi-arrow-right.m-l-10

</template>

<script>
export default {
  methods: {
    signIn() {
      this.$emit('signIn')
    }
  },
}
</script>

<i18n>
{
  "ja": {
    "sign-in-title": "あなたのサイトの実際のWebP対応シェアはどのくらい？",
    "signin-description": "WebPシェアチェッカーはGoogle Analyticsと連携し、過去30日分のブラウザの種類とバージョンのアクセスログを取得します。その情報を元にWebPユーザーシェアをレポートします。",
    "signin-catch": "ご利用は無料。一般論としてのWebP対応シェアではなく、あなたのサイトの実際のWebP対応シェアを簡単にチェックできます！",
    "sign-in": "サインインしてレポートを表示"
  },
  "en": {
    "sign-in-title": "How many users are available for WebP on your site?",
    "signin-description": "WebP Shere Checker queries this 30 days browser software and version access logs to Google Analytics, and reports WebP user share.",
    "signin-catch": "Free to use. You can check WebP user share not common but actual on your site!",
    "sign-in": "Sign in and create report"
  }
}
</i18n>